export const EDITOR_PERMISSIONS_ROLE = "EDITOR_PERMISSIONS_ROLE";
export const FREQUENCY_BUFFER = "FREQUENCY_BUFFER";
export const WIDGET_TARGETING = "WIDGET_TARGETING";
export const EXTRA_CHECKLIST_CUSTOMIZATION = "EXTRA_CHECKLIST_CUSTOMIZATION";
export const EVENT_TRIGGERING = "EVENT_TRIGGERING";
export const EVENT_ATTRIBUTE_TRIGGERING = "EVENT_ATTRIBUTE_TRIGGERING";
export const USE_LAUNCH_DARKLY = "USE_LAUNCH_DARKLY";
export const SALESFORCE_INTEGRATION = "SALESFORCE_INTEGRATION";
export const AB_TESTING = "AB_TESTING";
export const FLOW_LOCALIZATION = "FLOW_LOCALIZATION";
export const LOCALIZATION_RELEASED = "localization-released";
export const HUBSPOT_TWO_WAY_INTEGRATION = "hubspot-two-way-integration";
export const ZENDESK_SELL_INTEGRATION = "zendesk-sell-two-way-integration";
export const ZENDESK_SUPPORT_INTEGRATION =
  "zendesk-support-two-way-integration";
export const MULTI_APP_ENABLED = "MULTI_APP_ENABLED";
export const CREATE_NEW_ACCOUNTS = "CREATE_NEW_ACCOUNTS";
export const APPCUES_SIDEBAR_WIDGET = "appcues-sidebar-widget";